"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TwilsockError =
/*#__PURE__*/
function (_Error) {
  _inherits(TwilsockError, _Error);

  function TwilsockError(description) {
    _classCallCheck(this, TwilsockError);

    return _possibleConstructorReturn(this, _getPrototypeOf(TwilsockError).call(this, description));
  }

  return TwilsockError;
}(_wrapNativeSuper(Error));

exports.TwilsockError = TwilsockError;